import { ATMO, IMG } from "@/config/site";

export const SERVICE_PAGES = {
  gartenbau: {
    path: "/gartenbau",
    breadcrumb: "Landschaftsbau",
    eyebrow: "Leistung 02",
    titleLines: ["Garten- &", "Landschaftsbau"],
    seoTitle: "Garten- und Landschaftsbau Bremen | Hanse Garten Bremen",
    seoDescription:
      "Garten- und Landschaftsbau in Bremen: Neuanlage, Modellierung, Rasenflächen, Bepflanzung und Erdarbeiten. Hochwertige Materialien, saubere Umsetzung.",
    intro:
      "Wir bauen Außenräume mit hochwertigen Materialien und einem Blick für Details – von der Neuanlage bis zur vollständigen Umgestaltung.",
    image: ATMO.terrassiert,
    blocks: [
      {
        t: "Neuanlage & Umgestaltung",
        d: "Ob Neubau oder gewachsener Garten: Wir bereiten Flächen fachgerecht vor, bauen Substrate auf und setzen die Gestaltung um.",
      },
      {
        t: "Rasen & Grünflächen",
        d: "Rollrasen oder Ansaat, Bodenvorbereitung und präzise Randabschlüsse – für belastbare, ruhige Flächen.",
      },
      {
        t: "Bepflanzung",
        d: "Standortgerechte Auswahl von Gräsern, Stauden, Hecken und Bäumen, die langfristig funktioniert.",
      },
      {
        t: "Erd- & Randarbeiten",
        d: "Modellierung, Beeteinfassungen, Kies- und Splittflächen sowie saubere Übergänge zwischen den Bereichen.",
      },
    ],
    bullets: ["Rollrasen & Ansaat", "Beetanlage", "Heckenpflanzung", "Kies- & Splittflächen", "Baumpflanzung", "Bodenmodellierung"],
  },
  gartenplanung: {
    path: "/gartenplanung",
    breadcrumb: "Gartenplanung",
    eyebrow: "Leistung 01",
    titleLines: ["Gartenplanung", "mit Konzept"],
    seoTitle: "Gartengestaltung & Gartenplanung Bremen | Hanse Garten Bremen",
    seoDescription:
      "Gartenplanung in Bremen: von der ersten Idee bis zum konkreten Konzept. Individuelle Gartengestaltung passend zu Grundstück, Haus und Nutzung.",
    intro:
      "Von der ersten Idee bis zur konkreten Planung entwickeln wir gemeinsam mit Ihnen ein Konzept, das zu Ihrem Grundstück und Ihren Vorstellungen passt.",
    image: ATMO.editorial,
    blocks: [
      { t: "Bestandsaufnahme", d: "Wir erfassen Fläche, Boden, Licht, Sichtachsen und Bestand direkt vor Ort." },
      { t: "Nutzungskonzept", d: "Wo entsteht der Sitzplatz, wo Rasen, wo Sichtschutz? Zuerst die Funktion, dann die Form." },
      { t: "Material & Bepflanzung", d: "Auswahl von Belägen, Einfassungen und Pflanzen, die zusammenpassen und zum Haus gehören." },
      { t: "Ablauf & Budget", d: "Sie erhalten eine nachvollziehbare Reihenfolge der Arbeiten und einen klaren Kostenrahmen." },
    ],
    bullets: ["Vor-Ort-Aufnahme", "Flächenkonzept", "Materialauswahl", "Pflanzplanung", "Ablaufplanung", "Kostenrahmen"],
  },
  gartenpflege: {
    path: "/gartenpflege",
    breadcrumb: "Gartenpflege",
    eyebrow: "Leistung 06",
    titleLines: ["Gartenpflege", "das ganze Jahr"],
    seoTitle: "Gartenpflege Bremen | Heckenschnitt & Rasenpflege – Hanse Garten Bremen",
    seoDescription:
      "Gartenpflege in Bremen: Rasenpflege, Heckenschnitt, Beetpflege und saisonale Arbeiten. Einmalig oder dauerhaft – damit Ihr Garten gepflegt bleibt.",
    intro:
      "Damit Ihr Garten dauerhaft gepflegt bleibt – einmalig zur Saison oder regelmäßig über das Jahr.",
    image: IMG.formal,
    blocks: [
      { t: "Rasenpflege", d: "Mähen, Kanten schneiden, Vertikutieren, Nachsaat und Düngung im richtigen Rhythmus." },
      { t: "Hecken & Formschnitt", d: "Fachgerechter Schnitt zum richtigen Zeitpunkt – für dichte, gesunde Hecken." },
      { t: "Beet- & Staudenpflege", d: "Unkrautentfernung, Rückschnitt, Mulchen und Nachpflanzung." },
      { t: "Saisonarbeiten", d: "Laubentfernung, Winterschutz und Frühjahrsstart für Ihren Garten." },
    ],
    bullets: ["Rasenmähen", "Vertikutieren", "Heckenschnitt", "Beetpflege", "Laubentfernung", "Pflegeverträge"],
  },
  "terrassen-pflasterarbeiten": {
    path: "/terrassen-pflasterarbeiten",
    breadcrumb: "Terrassen & Pflaster",
    eyebrow: "Leistung 03",
    titleLines: ["Terrassen &", "Pflasterarbeiten"],
    seoTitle: "Terrassenbau & Pflasterarbeiten Bremen | Hanse Garten Bremen",
    seoDescription:
      "Terrassenbau und Pflasterarbeiten in Bremen: Wege, Einfahrten, Natursteinflächen und Terrassen – fachgerechter Aufbau, langlebig und passgenau.",
    intro:
      "Terrassen, Wege, Einfahrten und Flächen – funktional, langlebig und optisch passend zu Haus und Garten.",
    image: ATMO.stein,
    blocks: [
      { t: "Terrassen", d: "Platten-, Naturstein- und Holzflächen mit sauberen Fugenbildern und korrektem Gefälle." },
      { t: "Wege & Einfahrten", d: "Belastbarer Aufbau mit Tragschicht, Bettung und stabilen Randeinfassungen." },
      { t: "Randabschlüsse", d: "Bordsteine, Rasenkanten und Übergänge, die dauerhaft in Form bleiben." },
      { t: "Entwässerung", d: "Gefälle, Rinnen und Versickerung werden von Anfang an mitgeplant." },
    ],
    bullets: ["Betonpflaster", "Naturstein", "Plattenbeläge", "Holzdeck", "Einfahrten", "Entwässerung"],
  },
};
